import { render, staticRenderFns } from "./MultiSitesInformation.vue?vue&type=template&id=0fd245a3"
import script from "./MultiSitesInformation.vue?vue&type=script&lang=js"
export * from "./MultiSitesInformation.vue?vue&type=script&lang=js"
import style0 from "@/assets/css/multiple-sites-information.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports